import React from "react";
import type { MyResponse } from "../../types";
import { CheckCircle, Lock } from "@mui/icons-material";

export interface Props {
  response: MyResponse;
}

export const ResponseProgress = ({ response }: Props) => {
  return (
    <>
      {response.submitted ? (
        <CheckCircle
          sx={{
            mr: 1,
            color: "var(--color-green)",
          }}
          fontSize="large"
        />
      ) : (
        <Lock
          sx={{
            mr: 1,
            color: "var(--color-red)",
          }}
          fontSize="large"
        />
      )}
    </>
  );
};
